/**
 * 按钮效果
 *
 * 注意:
 *  目标元素需要定位,切overflow hidden
 *  需要手动释放
 *
 * Demo:
 *  let className = '.btn';
 *  let ripple = new Ripple(className);
 *  ripple.addEvent();
 *
 *  // 释放
 *  ripple.remove();
 */
class Ripple {
    constructor(className) {
        /**
         * 经过 clearTime ms后移除内部元素
         */
        this.clearTime = 500;
        this.className = className;
        this.init();
    }
    init() {
        if (Ripple.inited) {
            return;
        }
        Ripple.inited = true;
        this.initStyle();
    }
    /**
     * 初始化样式
     */
    initStyle() {
        const style = document.createElement('style');
        style.innerHTML = `
      .ripple-spin {
        width: 10px;
        height: 10px;
        background: #fff;
        position: absolute;
        border-radius: 50%;
        animation: ripple-wave ${this.clearTime / 1000}s ease-out;
        opacity: 0;
        transform: scale(50);
        animation-fill-mode: forwards;
        pointer-events: none;
      }

      @keyframes ripple-wave {
        from {
          opacity: 0.3;
          transform: scale(0);
        }

        to {
          opacity: 0;
          transform: scale(50);
          display: none;
        }
      }
    `;
        document.head.appendChild(style);
    }
    /**
     * 获取目标元素
     */
    getTargetElement() {
        if (this.element) {
            return this.element;
        }
        let element = document.querySelector(this.className);
        if (!element) {
            throw new Error('Element not found');
        }
        this.element = element;
        return element;
    }
    /**
     * 添加事件
     */
    addEvent() {
        if (this.callback) {
            return;
        }
        const element = this.getTargetElement();
        let callback = (e) => {
            const span = document.createElement('span');
            span.className = 'ripple-spin';
            span.style.left = e.offsetX + 'px';
            span.style.top = e.offsetY + 'px';
            element.appendChild(span);
            setTimeout(() => {
                element.removeChild(span);
            }, this.clearTime);
        };
        element.addEventListener('click', callback);
        this.callback = callback;
    }
    remove() {
        if (this.element && this.callback) {
            this.element.removeEventListener('click', this.callback);
            this.callback = void 0;
        }
    }
}
/**
 * 是否需要初始化
 */
Ripple.inited = false;
export default Ripple;
//# sourceMappingURL=data:application/json;base64,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